




import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import {Chart} from 'highcharts-vue';
import Highcharts from 'highcharts';
import vue from 'vue';

@Component({components: {Chart}})
export default class WaterfallChart extends Vue {
    @Prop() readonly series!: any;

    chartOptions: any = {
        chart: {
            type: 'waterfall',
            backgroundColor: 'transparent',
        },
        credits: {
            enabled: false,
        },
        title: {
            text: '',
        },

        xAxis: {
            type: 'category',
            labels: {
                style: {
                    fontSize: '1.2rem',
                },
            },
        },

        yAxis: {
            title: {
                text: '',
            },
            labels: {
                formatter() { return (vue as any).options.filters.KR((this as any).value); },
                style: { fontSize: '1.2rem' },
            },
            tickPixelInterval: 100,
        },

        legend: {
            enabled: false,
        },

        tooltip: {
            formatter(): any {
                return (Vue as any).options.filters.TKR((this as any).y);
            },
            style: {
                fontSize: '1.5rem',
                color: 'black',
            },
        },
        series: this.series,
    };

    @Watch('series', { immediate: true, deep: true })
    onDataChanged() {
        this.chartOptions.series = this.series;
    }

}


